import { shadows } from "../../themes/shadows/shadows.js";
import { typography } from "../../themes/typography/typography.js";
import "@mui/material";
import "../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../themes/typography/utils/typographyVariants/typographyVariants.js";
const chipStyles = ({
  color,
  variant
}) => ({
  ...typography["Lato Emphasized 2"],
  borderRadius: "8px",
  ...variant === "bordered" && {
    borderWidth: "1px",
    borderStyle: "solid",
    backgroundColor: "grey.50",
    ...color === "grey" && {
      color: "grey.800",
      borderColor: "grey.600",
      "&:hover": {
        borderColor: "grey.600",
        backgroundColor: "grey.200"
      },
      "&:focus-visible": {
        borderColor: "grey.800",
        backgroundColor: "grey.300"
      },
      "&:active": {
        borderColor: "grey.600",
        backgroundColor: "grey.300"
      }
    },
    "&.Mui-disabled": {
      color: "grey.400",
      backgroundColor: "grey.50",
      borderColor: "grey.400",
      opacity: 1,
      ".MuiSvgIcon-root": {
        color: "grey.400"
      }
    },
    ".MuiSvgIcon-root": {
      color: "grey.800",
      width: "16px",
      height: "16px"
    }
  },
  ...variant === "filled" && {
    color: "common.white",
    ...color === "aqua" && {
      backgroundColor: "primary.800",
      "&:hover": {
        boxShadow: shadows[7],
        backgroundColor: "primary.900"
      },
      "&:focus-visible": {
        backgroundColor: "primary.900"
      },
      "&:active": {
        backgroundColor: "primary.900"
      }
    },
    ...color === "blue" && {
      backgroundColor: "highlight2.800",
      "&:hover": {
        boxShadow: shadows[7],
        backgroundColor: "highlight2.900"
      },
      "&:focus-visible": {
        backgroundColor: "highlight2.900"
      },
      "&:active": {
        backgroundColor: "highlight2.900"
      }
    },
    ...color === "purple" && {
      backgroundColor: "highlight3.700",
      "&:hover": {
        boxShadow: shadows[7],
        backgroundColor: "highlight3.800"
      },
      "&:focus-visible": {
        backgroundColor: "highlight3.800"
      },
      "&:active": {
        backgroundColor: "highlight3.800"
      }
    },
    "&.Mui-disabled": {
      color: "grey.600",
      backgroundColor: "grey.400",
      opacity: 1,
      ".MuiSvgIcon-root": {
        color: "grey.600"
      }
    },
    ".MuiSvgIcon-root": {
      color: "common.white",
      width: "16px",
      height: "16px"
    }
  },
  ".MuiChip-label": {
    paddingLeft: "16px",
    paddingRight: "16px"
  },
  ".MuiChip-icon": {
    marginLeft: "8px",
    marginRight: "-8px"
  },
  ".MuiChip-deleteIcon": {
    marginLeft: "-8px",
    marginRight: "8px",
    "&:hover": {
      color: "unset"
    }
  }
});
export {
  chipStyles
};
